import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getModesData = createAsyncThunk(
  'modesdata/get',
  async (ga_num, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.get(`/api/modes/${ga_num}/`, ga_num)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
